import { render, staticRenderFns } from "./NewOnboarding.vue?vue&type=template&id=1508495a&scoped=true&"
import script from "./NewOnboarding.vue?vue&type=script&lang=js&"
export * from "./NewOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./NewOnboarding.vue?vue&type=style&index=0&id=1508495a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508495a",
  null
  
)

export default component.exports